"use client";
import Container from "@/components/Container";
import TextContent from "./components/text-content";
import Images from "./components/images";

const About = ({ slice }) => {
  return (
    <div>
      <section
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
        className="bg-[#47414F]"
      >
        <Container slice={slice}>
          <div className="relative pb-[220px] md:pb-[40px] xl:pb-[60px]">
            <TextContent
              title={slice?.primary?.title}
              description={slice?.primary?.description}
            />
          </div>
        </Container>
      </section>
      <Container className="relative">
        <Images images={slice?.primary?.images} />
      </Container>
    </div>
  );
};

export default About;
